<h3>Translation Center</h3>
<p>The place where you can find all your translations.</p>

<ng-container *ngIf="displayFullLanguage">
    <div class="alert alert-success d-flex align-items-center" role="alert">
        <i class="fa fa-check-circle mr-2"></i>
        <div>
            <strong>All Languages Translated:</strong>
            Congratulations! Your content has been successfully translated into all languages.
        </div>
    </div>
</ng-container>


<app-primas-toolbar #primasToolbar 
    [selectedCout]="primasTable?.selected?.length" (onAfterAddFinish)="refreshData(true)"
    (onAfterImportFinish)="refreshData(true)" [customView]="false" [table]="primasTable"
    [columns]="columns" (onAfterAddFinish)="refreshData(true)"
    (onAfterImportFinish)="refreshData(true)" 
    [resource]="permission.toolbar" [isShowEntitiesLimit]="true" [addEditComponet]="addEditComponent" [addNewAdditionalData]="addNewAdditionalData"
    (onDeletes)="onDeletes()">
</app-primas-toolbar>
<app-primas-table #primasTable (onRefresh)="refreshData($event)" [columnsTable]="columns" [resource]="permission.table" [optionHeight]="maxHeight" 
[customAction]="publishCustomAction" [addEditComponet]="addEditComponent" (onDelete)="onClickDelete($event)" [updateAdditionalData]="updateAdditionalData">
</app-primas-table>

<mat-dialog-actions align="end">
    <button mat-button (click)="onCloseClick()" [disabled]="primasTable.isLoading === 1">Close</button>
</mat-dialog-actions>

<ng-template #dateTimeCreated let-row="row">
    {{ row?.dateCreated | dateFormat }}
</ng-template>
<ng-template #dateTimeModified let-row="row">
    {{ row?.dateModified | dateFormat }}
</ng-template>
<ng-template #publish let-row="row">
    <div *ngIf="row?.isPublish === true">
        <mat-icon aria-hidden="false" aria-label="check_circle" class="success large">check_circle</mat-icon>
    </div>
</ng-template>
<ng-template #language let-row="row">
    <span *ngIf="!isLoadingLanguages; else loadingLang">
        {{ listLanguages[row?.lang] || row?.lang }}
    </span>
    <ng-template #loadingLang>
        <span>{{ row?.lang }}</span>
    </ng-template>
</ng-template>
<ng-template #togglePublish let-row="row">
    <button mat-menu-item (click)="onTogglePublish(row)">
        <mat-icon>
            {{ row?.isPublish ? 'visibility_off' : 'visibility' }}
        </mat-icon>
        <span>{{ row?.isPublish ? 'Unpublish' : 'Publish' }}</span>
    </button>
</ng-template>
<!-- For Category HyperData -->
<ng-template #leftBlogDescription let-row="row">
    {{ (row?.extendData | jsonParse )?.hyperData?.[0] || '' }}
</ng-template>
<ng-template #rightBlogDescription let-row="row">
    {{ (row?.extendData | jsonParse )?.hyperData?.[1] || '' }}
</ng-template>
<ng-template #askAnExpertDescription let-row="row">
    {{ (row?.extendData | jsonParse )?.hyperData?.[2] || '' }}
</ng-template>